module.exports = __webpack_public_path__ + "img/bin.0e1cd53c.svg";